import { render, staticRenderFns } from "./separationMenuTop.vue?vue&type=template&id=565a736a&scoped=true&"
import script from "./separationMenuTop.vue?vue&type=script&lang=js&"
export * from "./separationMenuTop.vue?vue&type=script&lang=js&"
import style0 from "./separationMenuTop.vue?vue&type=style&index=0&id=565a736a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565a736a",
  null
  
)

export default component.exports